import React from 'react';
import { ResponsiveContainer, PieChart, Pie, Cell } from 'recharts';
import { DarkCard, PieLegend, LegendItem } from './DashboardStyles';
import { CustomPieLabel } from './ChartUtils';

const RolesDistributionCard = ({ data = [] }) => {
    return (
        <DarkCard>
            <div className="card-title">Distribución de Roles</div>
            <ResponsiveContainer width="100%" height={160}>
                <PieChart>
                    <Pie
                        data={data}
                        cx="50%"
                        cy="50%"
                        innerRadius={35}
                        outerRadius={70}
                        dataKey="value"
                        labelLine={false}
                        label={<CustomPieLabel />}
                    >
                        {data.map((entry, index) => (
                            <Cell key={`cell-${index}`} fill={entry.color} />
                        ))}
                    </Pie>
                </PieChart>
            </ResponsiveContainer>
            <PieLegend>
                {data.map((item) => (
                    <LegendItem key={item.name} color={item.color}>
                        <div className="dot" />
                        {item.name}
                    </LegendItem>
                ))}
            </PieLegend>
        </DarkCard>
    );
};

export default RolesDistributionCard;
